import dataLayer from './dataLayer'

function avatarMenuClick (text) {
  dataLayer.add({
    event : 'topNavigationKonto',
    target : text
  })
}

function menuClick (isHamburger, text) {
  const event = isHamburger ? 'topNavigationHamburgarLink' : 'topNavigation'
  const eventAction = isHamburger ? 'hamburgarLink' : 'link'
  dataLayer.add({
    event : event,
    eventAction: eventAction,
    target : text
  })
}
function onOpenHamburgarMenu () {
  dataLayer.add({
    event : 'topNavigationHamburgarMenuOpen',
    eventAction: 'Open'
  })
}

function topNavLayout (size) {
  dataLayer.add({
    topNavLayout : size
  })
}

function logoClick () {
  dataLayer.add({
    event : 'topNavigation',
    eventAction : 'Hem',
    target : 'klickat på logga'
  })
}

function topNavStoreLink (url) {
  dataLayer.add({
    event : 'topNavigationTopLink',
    targetUrl: url
  })
}

function openedSearch () {
  dataLayer.add({
    event: "searchIconClick"
  })
}

function selectedStore (store) {
  store ? dataLayer.add({
    event: 'selectedStoreLoaded',
    storeInformation:{
      id: store.storeId.startsWith("0") ? store.storeId.substring(1) : store.storeId,
      name: store.storeName ? store.storeName.toLowerCase() : store.name.toLowerCase(),
      profile: store.profile?.toLowerCase()
    }
  }) : dataLayer.add({
    event: 'selectedStoreLoaded',
    storeInformation: undefined
  })
}

function selectStore () {
  dataLayer.add({
    event: 'selectStoreSelectYourStore'
  })
}

function toggleSelectNewStore (openState) {
  const toggleState = openState ? 'selectStoreOpenDropdown' : 'selectStoreCloseDropdown'
  dataLayer.add({
    event: toggleState
  })
}

function changeOrGoToStore (button, store) {
  button === 'changeStore' ? dataLayer.add({
    event: 'selectStoreChangeStore'
  }) : dataLayer.add({
    event: 'selectStoreGoToStore',
    storeInformation:{
      id: store.storeId.startsWith("0") ? store.storeId.substring(1) : store.storeId,
      name: store.storeName.toLowerCase(),
      profile: store.profile?.toLowerCase()
    },
    linkName: "gå till butik",
    linkUrl: !/^https?:\/\//i.test(store.LinkToWeb) ? window.location.origin + store.LinkToWeb : store.LinkToWeb,
  })
}

function storeSearch (showMore, query, results) {
  showMore ? dataLayer.add({
    event: 'selectStoreSearchShowMore'
  }) : dataLayer.add({
    event: 'selectStoreSearch',
    results: results,
    searchTerm: query
  })
}

function selectNewStore (store, tab) {
  dataLayer.add({
    event: 'selectStore',
    context: tab,
    storeInformation: {
      id: store.Id.toString(),
      name: store.Name.toLowerCase(),
      profile: store.ShortProfileName?.toLowerCase()
    }
  })
}

function storeCloseToMe () {
  dataLayer.add({
    event: 'selectStoreCloseToMe'
  })
}

export default {
  avatarMenuClick,
  menuClick,
  topNavLayout,
  onOpenHamburgarMenu,
  topNavStoreLink,
  openedSearch,
  logoClick,
  selectedStore,
  selectStore,
  changeOrGoToStore,
  storeSearch,
  storeCloseToMe,
  selectNewStore,
  toggleSelectNewStore
}
